<div class="flex__child--auto flex--column" data-test="employee">
  <router-outlet></router-outlet>
</div>
